import api from './api';

export const fetchServicePage = async (slug) => {
  const response = await api.get(`/services/${encodeURIComponent(slug)}`);
  return response.data;
};
